function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 1.5C4.41 1.5 1.5 4.41 1.5 8s2.91 6.5 6.5 6.5 6.5-2.91 6.5-6.5S11.59 1.5 8 1.5zm1.647 8.853L8 8.706l-1.647 1.647A.502.502 0 015.5 10a.5.5 0 01.147-.353L7.294 8 5.647 6.353a.5.5 0 11.706-.706L8 7.294l1.647-1.647a.502.502 0 01.706 0 .502.502 0 010 .706L8.706 8l1.647 1.647a.502.502 0 010 .706.496.496 0 01-.706 0z"
});

function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
}

export default SvgCloseCircle;